import Products from './Products';

export default Products;


// WEBPACK FOOTER //
// ./src/components/Featured/components/Products/index.tsx